import { format } from 'date-fns';

/** Return `true` if date is invalid */
export const isInvalidDate = (date?: Date) => (date ? isNaN(date?.getTime()) : true);

/** Format date to us pattern: yyyy-MM-dd */
export const formatDateToUs = (date: Date) => format(date, 'yyyy-MM-dd');
